(function(){
  const root = document.documentElement;
  const bgEl = document.getElementById('global-blur-bg');
  if(!bgEl) return;

  function cssUrl(u){ return u ? `url("${u}")` : 'none'; }

  function pickFallback(){
    // 1) 优先：hero 当前 slide（你的 hero-interactive）
    const active = document.querySelector('.hero-wrapper .carousel-slide.active');
    if(active){
      const bg = active.style.backgroundImage;
      if(bg && bg !== 'none') return bg;
    }

    // 2) 次优：当前页面第一张可见大图
    const img = document.querySelector('main img');
    if(img){
      const u = img.currentSrc || img.src;
      if(u) return cssUrl(u);
    }

    return 'none';
  }

  function setBG(bg){
    root.style.setProperty('--gbg-img', bg || pickFallback());
  }

  // 初次
  setBG();

  // 接收 hero 主动同步
  window.addEventListener('hero:bgchange', (e)=>{
    const bg = e?.detail?.bg;
    if(bg) setBG(bg);
  });

  // 主题编辑器/切换 section 时兜底
  document.addEventListener('shopify:section:load', ()=> setBG());
  document.addEventListener('shopify:section:reorder', ()=> setBG());
})();
